import { render, staticRenderFns } from "./DeliveryLocationsCard.vue?vue&type=template&id=68765679&scoped=true"
import script from "./DeliveryLocationsCard.vue?vue&type=script&lang=js"
export * from "./DeliveryLocationsCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryLocationsCard.vue?vue&type=style&index=0&id=68765679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68765679",
  null
  
)

export default component.exports